module.exports = __webpack_public_path__ + "static/media/Cesena.2f131b1d.png";